module.exports = __webpack_public_path__ + "img/gb99.prt.2ef7ec91.jpg";